import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { CompaniesService } from '@services/companies.service';

@Injectable()
export class CompanyCreateGuard implements CanActivate {
  constructor(private companiesService: CompaniesService, private router: Router) {}

  public canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.companiesService.getCompanyAsync().pipe(
      map((e) => {
        if (!!e) {
          this.router.navigate(['']);
        }
        return !e;
      }),
    );
  }
}
